import React from 'react';
import { useTranslation } from 'react-i18next';

import css from './promoteVipPopupPrice.module.sass';

interface Props {
  initialPrice: string;
  discountedPrice: string;
  isSpecialOffer: boolean;
}

export const PromoteVipPopupPrice: React.FC<Props> = ({
  initialPrice,
  discountedPrice,
  isSpecialOffer,
}) => {
  const { t } = useTranslation('app');

  return (
    <div className={css.root}>
      <p className={css.discounted}>{discountedPrice}</p>
      <p className={css.initial}>{initialPrice}</p>
      {isSpecialOffer && (
        <span className={css.label}>{t('promoteVipPopup.bestOffer')}</span>
      )}
    </div>
  );
};
